import { render, staticRenderFns } from "./UpdateReportFrameworkArchives.vue?vue&type=template&id=4d94e763"
import script from "./UpdateReportFrameworkArchives.vue?vue&type=script&lang=js"
export * from "./UpdateReportFrameworkArchives.vue?vue&type=script&lang=js"
import style0 from "./UpdateReportFrameworkArchives.vue?vue&type=style&index=0&id=4d94e763&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
